import React from 'react';
import PropTypes from 'prop-types';

import pallet from 'constants/colors';

import KButton from './KButton';

const styles = {
  button: {
    textDecoration: 'none',
    fontWeight: 600,
    color: pallet.primary1Color,
    maxWidth: 150,
    textTransform: 'uppercase',
    backgroundColor: 'transparent',
  },
};

const KFlatButton = props => <KButton flat {...props} buttonStyle={{ ...styles.button, ...props.style }} />;

KFlatButton.propTypes = { style: PropTypes.object };

export default KFlatButton;



// WEBPACK FOOTER //
// ./src/components/KJRN/KFlatButton.js